<template>
    <ul class="filter filtering-component-filter">
        <li class="filter__item" v-if="industryTags.length > 0">
            <label for="industryTagFilter" class="sr-only">{{ dictionary.IndustryDefaultTag }}</label>
            <select id="industryTagFilter" v-model="industryTag" :disabled="isLoading">
                <option value="Industry">{{ dictionary.IndustryDefaultTag }}</option>
                <option v-for="tagItem in industryTags" :key="tagItem.Key" :value="tagItem.Key">{{
                    tagItem.Name
                }}</option>
            </select>
        </li>
        <li class="filter__item" v-if="solutionTags.length > 0">
            <label for="solutionTagFilter" class="sr-only">{{ dictionary.SolutionDefaultTag }}</label>
            <select id="solutionTagFilter" v-model="solutionTag" :disabled="isLoading">
                <option value="Solution">{{ dictionary.SolutionDefaultTag }}</option>
                <option v-for="tagItem in solutionTags" :key="tagItem.Key" :value="tagItem.Key">{{
                    tagItem.Name
                }}</option>
            </select>
        </li>
        <li class="filter__item" v-if="typeTags.length > 0">
            <label for="typeTagFilter" class="sr-only">{{ dictionary.TypeDefaultTag }}</label>
            <select id="typeTagFilter" v-model="typeTag" :disabled="isLoading">
                <option value="Type">{{ dictionary.TypeDefaultTag }}</option>
                <option v-for="tagItem in typeTags" :key="tagItem.Key" :value="tagItem.Key">{{
                    tagItem.Name
                }}</option>
            </select>
        </li>
    </ul>
    <ul class="filtering-component__items">
        <li class="article-item" v-for="project in articles" :key="project.Id">
            <a :href="project.Url" class="article-item__link">
                <div class="article-item__inner">
                    <div class="article-item__image">
                        <ResponsiveImage v-if="project.ImageForVue != null" :imageModel="project.ImageForVue"
                            :key="project.Id" />
                    </div>
                    <div class="article-item__text">
                        <div v-if="showTags" class="article-item__tags">
                            <div v-for="industryTag in project.IndustryTags" v-if="project.IndustryTags != null"
                                class="article-item__tags-tag">
                                {{ industryTag }}
                            </div>
                            <div v-for="solutionTag in project.SolutionTags" v-if="project.SolutionTags != null"
                                class="article-item__tags-tag">
                                {{ solutionTag }}
                            </div>
                        </div>
                        <div v-for="typeTag in project.TypeTags" v-if="project.TypeTags != null"
                            class="article-item__tags-type">
                            {{ typeTag }}
                        </div>
                        <h3 class="article-item__headline">
                            {{ project.Headline }}
                        </h3>
                    </div>
                </div>
            </a>
        </li>
    </ul>
    <div class="filtering-component__cta">
        <div class="filtering-component__load-more" v-show="hasMoreArticles">
            <a @click="getNextPage" :disabled="isLoading">{{
                dictionary.FilteringLoadMore
            }}</a>
        </div>
    </div>
</template>

<script>
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";
import { nextTick } from 'vue'

const serviceUrl = "/umbraco/api/filteringapi/GetFilteringArticles";
const defaultIndustryTag = "Industry";
const defaultSolutionTag = "Solution";
const defaultTypeTag = "Type";

export default {
    name: "FilteringComponent",
    components: {
        ResponsiveImage
    },
    data() {
        return {
            dictionary: [],
            industryTags: [],
            solutionTags: [],
            typeTags: [],
            culture: "da-DK",
            articles: [],
            pageSize: 9,
            page: 1,
            totalArticles: 0,
            prefilterIndustry: defaultIndustryTag,
            hasPreFilterIndustry: false,
            prefilterSolution: defaultSolutionTag,
            hasPreFilterSolution: false,
            prefilterType: defaultTypeTag,
            hasPreFilterType: false,
            isLoading: false,
            hasLoadedInitials: false,
            filteringComponentNodeIds: 0,
            showTags: false,
            isResetting: false
        };
    },
    mixins: [
        bindRoute({
            industryTag: defaultIndustryTag,
            solutionTag: defaultSolutionTag,
            typeTag: defaultTypeTag,
            isWorking: false
        }),
    ],
    watch: {
        industryTag: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        solutionTag: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        typeTag: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        }
    },
    created() {
        this.filteringComponentNodeIds = this.$parent.filteringComponentNodeIds;
        this.pageSize = this.$parent.pageSize;
        this.showTags = this.$parent.showTags == "True";

        this.$router.isReady().then(() => {
            this.getInitialArticles();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleFilterPropertyChange(oldVal, newVal) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged();
                }
            }
        },
        getArticles(amountToSkip, pageSize) {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                filteringComponentNodeIds: vm.filteringComponentNodeIds,
                languageCode: languageCode,
                amountToSkip: amountToSkip,
                pageSize: pageSize,
                showTags: vm.showTags
            };

            if (vm.industryTag != defaultIndustryTag) {
                object.industryTag = vm.industryTag;
            }

            if (vm.solutionTag != defaultSolutionTag) {
                object.solutionTag = vm.solutionTag;
            }

            if (vm.typeTag != defaultTypeTag) {
                object.typeTag = vm.typeTag;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {
                    vm.articles.push(...data.Items);
                    vm.industryTags = data.Facets.IndustryTags;
                    vm.solutionTags = data.Facets.SolutionTags;
                    vm.typeTags = data.Facets.TypeTags;
                    vm.dictionary = data.Dictionary;
                    vm.totalArticles = data.TotalItems;
                    vm.hasLoadedInitials = true;
                    vm.toggleSpinner(false);
                    vm.isResetting = false;

                    window.history.replaceState({}, document.title, window.location.pathname);
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                this.getArticles(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialArticles() {
            // Get all cases up to, and including, the current page
            const initialPageSize = this.pageSize * this.page;
            this.getArticles(0, initialPageSize);
        },
        filterChanged() {
            this.articles = [];
            this.totalArticles = 0;
            this.page = 1;
            this.getArticles(0, this.pageSize);
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreArticles() {
            return (
                this.totalArticles !== 0 &&
                this.articles.length < this.totalArticles
            );
        },
        hasFilterApplied() {
            return this.industryTag != defaultIndustryTag && !this.hasPreFilterIndustry ||
                this.solutionTag != defaultSolutionTag && !this.hasPreFilterSolution ||
                this.typeTag != defaultTypeTag && !this.hasPreFilterType;
        }
    },
};
</script>